import {
    BOARD_MEMBER_PLACEHOLDER_IMAGE,
} from '../data/managementBoard';

/**
 * @param {{
 *   role: string,
 *   name: string,
 *   image?: string | null,
 * }} props
 */
export function BoardMemberCard({ role, name, image = null }) {
    const src = image || BOARD_MEMBER_PLACEHOLDER_IMAGE;

    return (
        <article
            className="board-member-card"
            aria-label={`${name}, ${role}`}
        >
            <div className="board-member-card-role">{role}</div>
            <div className="board-member-card-photo-wrap">
                <img
                    src={src}
                    alt=""
                    className="board-member-card-photo"
                    width={280}
                    height={340}
                    loading="lazy"
                    decoding="async"
                />
            </div>
            <div className="board-member-card-name">{name}</div>
        </article>
    );
}
